import styled from '@emotion/styled';
import { Button, TableCell, TableRow } from '@material-ui/core';
import { greens, greys, white } from '@/styles/colors';
import { sansSerif } from '@/styles/typography';

// Figma: Corporate Account — Discovery, "Agreed tariffs". A table with a status badge per row,
// replacing the stacked bordered rows the panel used to draw.

const HEADER_GREY = '#8A8F98';

export const Toolbar = styled.div`
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: flex-end;
    margin-bottom: 16px;
`;

export const ToolbarSpacer = styled.div`
    flex: 1;
`;

export const TableCard = styled.div`
    background: ${white.primary};
    border: 1px solid ${greys.border};
    border-radius: 10px;
    overflow: hidden;
`;

export const HeaderCell = styled(TableCell)`
    background: ${white.primary};
    border-bottom: 1px solid ${greys.border};
    color: ${HEADER_GREY};
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.7px;
    padding: 12px 20px;
    text-transform: uppercase;
    white-space: nowrap;
`;

export const BodyRow = styled(TableRow)`
    cursor: pointer;

    &:hover {
        background: ${white.secondary};
    }
`;

export const BodyCell = styled(TableCell)`
    border-bottom: 1px solid ${greys.border};
    color: ${greys.secondary};
    font-size: 14px;
    padding: 14px 20px;
    vertical-align: middle;
`;

export const TariffName = styled.span`
    color: #0c0b1d;
    display: block;
    font-size: 15px;
    font-weight: 700;
`;

export const KindText = styled.span`
    color: ${greys.secondary};
    font-size: 13px;
`;

// The design draws DRAFT in red and LINKED in green. The green badge marks the tariff the
// account-wide override or driver mapping points at. It reads "Default", matching the Order tab
// and the "Change to default" action, rather than the design's "Linked".
export const StatusBadge = styled.span`
    align-items: center;
    background: ${({ linked }) => (linked ? '#E6F6E9' : greys.selected)};
    border-radius: 6px;
    color: ${({ linked }) => (linked ? '#1E7B2C' : greys.primary)};
    display: inline-flex;
    font-size: 11px;
    font-weight: 700;
    gap: 6px;
    letter-spacing: 0.6px;
    padding: 4px 10px;
    text-transform: uppercase;
`;

export const StatusDot = styled.span`
    background: ${greens.primary};
    border-radius: 50%;
    height: 6px;
    width: 6px;
`;

export const RowActions = styled.div`
    align-items: center;
    display: inline-flex;
    gap: 4px;
    justify-content: flex-end;
`;

export const LinkAction = styled.button`
    ${sansSerif}
    background: none;
    border: none;
    color: ${greens.primary};
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    padding: 0 8px;
    white-space: nowrap;

    &:disabled {
        color: ${greys.subtitle};
        cursor: default;
    }
`;

export const OutlinedAction = styled(Button)`
    ${sansSerif}
    border: 1px solid ${greys.border};
    border-radius: 6px;
    color: ${greys.secondary};
    font-size: 13px;
    font-weight: 700;
    min-width: 0;
    padding: 4px 18px;
    text-transform: none;
`;

export const EmptyState = styled.div`
    align-items: center;
    color: ${greys.primary};
    display: flex;
    font-size: 14px;
    justify-content: center;
    padding: 2.5rem 1rem;
`;
